import {
  Component,
  OnInit,
  Input,
  TemplateRef,
  ViewChild,
  Output,
  EventEmitter,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { InteractorService } from 'src/app/core/services/interactor.service';

@Component({
  selector: 'app-confirm-save',
  templateUrl: './confirm-save.component.html',
  styleUrls: ['./confirm-save.component.scss'],
})
export class ConfirmSaveComponent implements OnInit {
  modalRef: BsModalRef;
  @Input() Message: string;
  @Output() modalEvent = new EventEmitter<boolean>();
  @ViewChild('template') elementView: TemplateRef<any>;
  @Input() btnLabel = 'Save';
  @Input() onShareAgency;
  brandingDetails = JSON.parse(localStorage.getItem('branding'));
  btnDelete=this.brandingDetails?.branding?.BackgroundColors?.ConfirmDeleteBtnHover;
  constructor(
    private modalService: BsModalService,
    private interactorService: InteractorService,
    private translatorService: TranslateService
    ) {
      this.translatorService.setDefaultLang('en');
      this.translatorService.use(localStorage.getItem('lang') || 'en');
    }

  ngOnInit(): void {
    this.interactorService.brandingDetailsCast.subscribe(data => {
      if (data) {
        this.brandingDetails = data;
        document.documentElement.style.setProperty('--btnDelete', this.brandingDetails?.branding?.BackgroundColors?.ConfirmDeleteBtnHover);
      }
      this.setBackgroundColors();
    });
    this.interactorService.inviteToCompleteBrandingDetailsCast.subscribe(data => {
      if (data) {
        this.brandingDetails = data;
        document.documentElement.style.setProperty('--btnDelete', this.brandingDetails?.branding?.BackgroundColors?.ConfirmDeleteBtnHover);
      }
      this.setBackgroundColors();
    });
    document.documentElement.style.setProperty('--btnDelete', this.brandingDetails?.branding?.BackgroundColors?.ConfirmDeleteBtnHover);
  }

  /**
   * Function to open modal
   */
  public openModal() {
    this.modalRef = this.modalService.show(this.elementView, {
      class: this.onShareAgency + ' ' + 'modal-dialog-centered',
    });
  }

  /**
   * Function to close modal and emit event
   */
  public confirm(value) {
    this.modalEvent.emit(value);
    this.modalRef.hide();
  }
  setBackgroundColors(){
    this.btnDelete=this.brandingDetails?.branding?.BackgroundColors?.ConfirmDeleteBtnHover;
  }
}
